export class User {
    id: number;
    gmid: string;
    name: string;
    email: string;
    businessFunction: string;
    roles: string[];
    isAdmin: boolean;
    isPSC: boolean;
    bac: string;
    language: string;
    isSuperAdmin: boolean;

    constructor(json: any = null) {
        if (!json) return;

        this.id = json.id;
        this.gmid = json.gmid;
        this.name = json.name;
        this.email = json.email;
        this.businessFunction = json.businessFunction;
        this.roles = json.roles;
        this.isAdmin = json.isAdmin;
        this.isPSC = json.isPSC;
        this.bac = json.bac;
        this.language = json.language;
        this.isSuperAdmin = json.isSuperAdmin;
    }
}